import { getKPIRequest } from "@/api/getKPIRequest"
import type { KPIGroupRequest, KPIRequest } from "@/types/kpiTypes"

export const getDigesterKPIs = async (asOf: Date, kpis: KPIRequest[]) => {
  const dayRequest: KPIGroupRequest = {
    asOf,
    returnSize: 1,
    kpis,
  }
  const mtdRequest: KPIGroupRequest = {
    asOf,
    returnSize: 1,
    kpis,
    aggType: "Monthly",
  }

  return {
    day: await getKPIRequest(dayRequest),
    mtd: await getKPIRequest(mtdRequest),
  }
}
